import { render } from "./BpmOgpoPaymentSuccess.vue?vue&type=template&id=fa8b3c64"
import script from "./BpmOgpoPaymentSuccess.vue?vue&type=script&lang=js"
export * from "./BpmOgpoPaymentSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__